import React, { useEffect, useRef, useState, useCallback } from 'react';

const ReponsiveImage = ({ imagePath, leftRightPadding, topBottomPadding, headerCompensate, angularScope}) => {

  let elementRef = useRef(null);
  let imageRef = useRef(null);

  const [originalWidth, setOriginalWidth] = useState('');
  const [originalHeight, setOriginalHeight] = useState('');

  const resize = useCallback((callback) => {
    
    var result = {};

    const lrPadding = leftRightPadding || 0;
    const tbPadding = topBottomPadding || 0;
    const hCompensate = headerCompensate || 0;

    var imageWidth = imageRef.current.width;
    var imageHeight = imageRef.current.height;
    var containerWidth = elementRef.current.parentNode.clientWidth - lrPadding;
    var containerHeight = elementRef.current.parentNode.clientHeight - tbPadding;

    var scaleX1 = containerWidth;
    var scaleY1 = (imageHeight * containerWidth) / imageWidth;

    var scaleX2 = (imageWidth * containerHeight) / imageHeight;
    var scaleY2 = containerHeight;

    var scaleOnWidth = (scaleX2 > containerWidth);

    if (scaleOnWidth) {
      result.width = Math.floor(scaleX1) > originalWidth ? originalWidth : Math.floor(scaleX1);
      result.height = Math.floor(scaleY1) > originalHeight ? originalHeight : Math.floor(scaleY1);
    }
    else {
      result.width = Math.floor(scaleX2) > originalWidth ? originalWidth : Math.floor(scaleX2);
      result.height = Math.floor(scaleY2) > originalHeight ? originalHeight : Math.floor(scaleY2);
    }

    if (!originalWidth) { result.width = Math.floor(scaleX1) }

    result.targetleft = Math.floor((containerWidth - result.width) / 2);
    result.targettop = Math.floor((containerHeight - result.height) / 2);

    elementRef.current.style.cssText = `height: ${result.height}px;
                                        width: ${result.width}px;
                                        left: ${result.targetleft + lrPadding / 2}px;
                                        top: ${result.targettop + (tbPadding / 2) - hCompensate}px`;

    if (callback) { setTimeout(function () { callback(); }) }
  }, [elementRef, imageRef, originalHeight, originalWidth, leftRightPadding, topBottomPadding, headerCompensate])

  useEffect(() => {

    const callResize = () => {
      if (elementRef.current.parentNode.clientWidth < 200 || elementRef.current.parentNode.clientHeight < 250) { return; }
      resize();
    }

    window.addEventListener('resize', callResize)

    return () => {
      window.removeEventListener('resize', callResize)
    }
  }, [resize])

  useEffect(() => {
    if (imageRef.current) {
      imageRef.current.addEventListener('load', function () {

        setOriginalWidth(imageRef.current.width);
        setOriginalHeight(imageRef.current.height);

        angularScope.$broadcast('previewLoaded', { isImage: true })

        resize();      
        
      }, { once: true })
    }

  }, [imagePath, angularScope, resize])

  return (
    <div ref={elementRef} className="image-preview">
      <img alt="Preview" ref={imageRef} src={imagePath} />
    </div>
  )
}

export default ReponsiveImage;